// import React, { useState, useEffect } from "react";

// const About = () => {
//     const [isMobile, setIsMobile] = useState(false);
//     const [hoveredCard, setHoveredCard] = useState(null);

//     useEffect(() => {
//         const handleResize = () => setIsMobile(window.innerWidth < 768);
//         handleResize();
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     // Brand manufacturer details modeled after Bisleri and Kinley standards
//     const techSpecs = [
//         {
//             icon: "🔬",
//             title: "10-STAGE PURIFICATION",
//             subtitle: "Ozonated & UV Treated",
//             desc: "Every drop undergoes a rigorous multi-tier filtration pipeline including dual-stage sand filtering, activated carbon blocks, reverse osmosis (RO), and final state-of-the-art micro-filtration layers."
//         },
//         {
//             icon: "⛰️",
//             title: "MINERAL ENRICHMENT",
//             subtitle: "Magnesium & Potassium",
//             desc: "We scientifically re-introduce precise quantities of essential minerals post-filtration. This guarantees a crisp, refreshing taste balance while matching critical metabolic parameters."
//         },
//         {
//             icon: "🏭",
//             title: "AUTOMATED BOTTLING",
//             subtitle: "Zero-Touch Production",
//             desc: "Our high-speed industrial facilities use blow-molding and non-contact pneumatic rinsing systems. This ensures complete clinical safety from the initial raw shell form down to final packaging."
//         }
//     ];

//     const styles = {
//         wrapper: {
//             minHeight: "100vh",
//             width: "100%",
//             background: "#2c3437",
//             backgroundImage: "url('https://transparenttextures.com')",
//             backgroundRepeat: "repeat",
//             backgroundBlendMode: "multiply",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             alignItems: "center",
//             fontFamily: "'Montserrat', sans-serif",
//             color: "white",
//             padding: isMobile ? "80px 20px" : "120px 40px",
//             boxSizing: "border-box",
//             position: "relative",
//             overflow: "hidden",
//         },
//         container: {
//             width: "100%",
//             maxWidth: "1100px",
//             zIndex: 2,
//             position: "relative",
//         },
//         headerSection: {
//             textAlign: "center",
//             marginBottom: isMobile ? "50px" : "80px",
//         },
//         tagline: {
//             color: "#6ec1e4",
//             letterSpacing: "3px",
//             fontSize: isMobile ? "12px" : "14px",
//             fontWeight: "600",
//             textTransform: "uppercase",
//             marginBottom: "12px",
//         },
//         mainTitle: {
//             fontSize: isMobile ? "30px" : "44px",
//             fontWeight: "900",
//             letterSpacing: "1px",
//             lineHeight: 1.2,
//             color: "#ffffff",
//             margin: "0 auto 20px auto",
//             maxWidth: "800px",
//         },
//         divider: {
//             width: "60px",
//             height: "3px",
//             backgroundColor: "#6ec1e4",
//             margin: "0 auto",
//             borderRadius: "2px",
//         },
//         grid: {
//             display: "grid",
//             gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr",
//             gap: isMobile ? "25px" : "35px",
//             alignItems: "stretch",
//         },
//         card: (idx) => ({
//             backgroundColor: "rgba(255, 255, 255, 0.02)",
//             border: hoveredCard === idx ? "1px solid #6ec1e4" : "1px solid rgba(255, 255, 255, 0.08)",
//             borderRadius: "24px",
//             padding: isMobile ? "30px 20px" : "40px 30px",
//             transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
//             transform: hoveredCard === idx ? "translateY(-8px)" : "translateY(0)",
//             boxShadow: hoveredCard === idx ? "0px 15px 35px rgba(110,193,228,0.15)" : "none",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "flex-start",
//             cursor: "default",
//         }),
//         iconWrapper: (idx) => ({
//             fontSize: "32px",
//             width: "60px",
//             height: "60px",
//             backgroundColor: hoveredCard === idx ? "rgba(110, 193, 228, 0.15)" : "rgba(255, 255, 255, 0.04)",
//             borderRadius: "18px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             marginBottom: "24px",
//             transition: "all 0.3s ease",
//             border: hoveredCard === idx ? "1px solid rgba(110,193,228,0.3)" : "1px solid transparent",
//         }),
//         cardTitle: {
//             fontSize: "17px",
//             fontWeight: "800",
//             letterSpacing: "1px",
//             color: "#ffffff",
//             marginBottom: "6px",
//         },
//         cardSubtitle: {
//             fontSize: "12px",
//             fontWeight: "600",
//             color: "#6ec1e4",
//             letterSpacing: "1px",
//             textTransform: "uppercase",
//             marginBottom: "18px",
//         },
//         cardDesc: {
//             fontSize: "14px",
//             color: "#b3bfc4",
//             lineHeight: "1.7",
//             fontWeight: "300",
//             margin: 0,
//         },
//         specBar: {
//             marginTop: isMobile ? "50px" : "80px",
//             backgroundColor: "rgba(0, 0, 0, 0.2)",
//             border: "1px solid rgba(255, 255, 255, 0.04)",
//             borderRadius: "24px",
//             padding: isMobile ? "30px 20px" : "35px 50px",
//             display: "flex",
//             flexDirection: isMobile ? "column" : "row",
//             justifyContent: "space-between",
//             alignItems: "center",
//             gap: isMobile ? "30px" : "20px",
//             textAlign: "center",
//         },
//         statUnit: {
//             flex: 1,
//         },
//         statNum: {
//             fontSize: isMobile ? "32px" : "40px",
//             fontWeight: "900",
//             color: "#6ec1e4",
//             marginBottom: "4px",
//             fontFamily: "monospace",
//         },
//         statLabel: {
//             fontSize: "11px",
//             color: "#cfd8dc",
//             letterSpacing: "1.5px",
//             fontWeight: "500",
//             textTransform: "uppercase",
//         }
//     };

//     return (
//         <div id="aboutus" style={styles.wrapper}>
//             <div style={styles.container}>
                
//                 {/* Upper Screen Title Blocks */}
//                 <div style={styles.headerSection}>
//                     <div style={styles.tagline}>IS 14543 Compliance</div>
//                     <h2 style={styles.mainTitle}>India's Premium Class Packaged Drinking Water</h2>
//                     <div style={styles.divider} />
//                 </div>

//                 {/* Core Three Column Technical Grid */}
//                 <div style={styles.grid}>
//                     {techSpecs.map((spec, idx) => (
//                         <div
//                             key={spec.title}
//                             style={styles.card(idx)}
//                             onMouseEnter={() => setHoveredCard(idx)}
//                             onMouseLeave={() => setHoveredCard(null)}
//                         >
//                             <div style={styles.iconWrapper(idx)}>{spec.icon}</div>
//                             <h3 style={styles.cardTitle}>{spec.title}</h3>
//                             <div style={styles.cardSubtitle}>{spec.subtitle}</div>
//                             <p style={styles.cardDesc}>{spec.desc}</p>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Bottom Scientific Specification Ribbon Bar */}
//                 <div style={styles.specBar}>
//                     <div style={styles.statUnit}>
//                         <div style={styles.statNum}>100%</div>
//                         <div style={styles.statLabel}>ISI Certified Safe</div>
//                     </div>
//                     <div style={{
//                         ...styles.statUnit, 
//                         borderLeft: isMobile ? "none" : "1px solid rgba(255,255,255,0.1)",
//                         borderRight: isMobile ? "none" : "1px solid rgba(255,255,255,0.1)",
//                         padding: isMobile ? "20px 0" : "0 20px"
//                     }}>
//                         <div style={styles.statNum}>Optimum</div>
//                         <div style={styles.statLabel}>Minerals Re-infused</div>
//                     </div>
//                     <div style={styles.statUnit}>
//                         <div style={styles.statNum}>BPA</div>
//                         <div style={styles.statLabel}>Free Food-Grade PET</div>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default About;


import React, { useState } from "react";

const TECH_SPECS = [
  {
    icon: "🔬",
    title: "10-STAGE PURIFICATION",
    subtitle: "Ozonated & UV Treated",
    desc: "Every drop undergoes a rigorous multi-tier filtration pipeline including dual-stage sand filtering, activated carbon blocks, reverse osmosis (RO), and final state-of-the-art micro-filtration layers."
  },
  {
    icon: "⛰️",
    title: "MINERAL ENRICHMENT",
    subtitle: "Magnesium & Potassium",
    desc: "We scientifically re-introduce precise quantities of essential minerals post-filtration. This guarantees a crisp, refreshing taste balance while matching critical metabolic parameters."
  },
  {
    icon: "🏭",
    title: "AUTOMATED BOTTLING",
    subtitle: "Zero-Touch Production",
    desc: "Our high-speed industrial facilities use blow-molding and non-contact pneumatic rinsing systems. This ensures complete clinical safety from the initial raw shell form down to final packaging."
  }
];

const About = ({ isMobile }) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div
      id="aboutus"
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#2c3437",
        backgroundImage: "url('https://transparenttextures.com')",
        backgroundRepeat: "repeat",
        backgroundBlendMode: "multiply",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Montserrat', sans-serif",
        color: "white",
        padding: isMobile ? "80px 20px" : "120px 40px",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1100px",
          zIndex: 2,
          position: "relative",
        }}
      >
        {/* Upper Screen Title Blocks */}
        <div
          style={{
            textAlign: "center",
            marginBottom: isMobile ? "50px" : "80px",
          }}
        >
          <div
            style={{
              color: "#6ec1e4",
              letterSpacing: "3px",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
              textTransform: "uppercase",
              marginBottom: "12px",
            }}
          >
            IS 14543 Compliance
          </div>
          <h2
            style={{
              fontSize: isMobile ? "30px" : "44px",
              fontWeight: "900",
              letterSpacing: "1px",
              lineHeight: 1.2,
              color: "#ffffff",
              margin: "0 auto 20px auto",
              maxWidth: "800px",
            }}
          >
            India's Premium Class Packaged Drinking Water
          </h2>
          <div
            style={{
              width: "60px",
              height: "3px",
              backgroundColor: "#6ec1e4",
              margin: "0 auto",
              borderRadius: "2px",
            }}
          />
        </div>

        {/* Core Three-Column Technical Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr",
            gap: isMobile ? "25px" : "35px",
            alignItems: "stretch",
          }}
        >
          {TECH_SPECS.map((spec, idx) => {
            const isHovered = hoveredCard === idx;
            return (
              <div
                key={spec.title}
                onMouseEnter={() => setHoveredCard(idx)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.02)",
                  border: isHovered
                    ? "1px solid #6ec1e4"
                    : "1px solid rgba(255, 255, 255, 0.08)",
                  borderRadius: "24px",
                  padding: isMobile ? "30px 20px" : "40px 30px",
                  transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  transform: isHovered ? "translateY(-8px)" : "translateY(0)",
                  boxShadow: isHovered
                    ? "0px 15px 35px rgba(110,193,228,0.15)"
                    : "none",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  cursor: "default",
                }}
              >
                <div
                  style={{
                    fontSize: "32px",
                    width: "60px",
                    height: "60px",
                    backgroundColor: isHovered
                      ? "rgba(110, 193, 228, 0.15)"
                      : "rgba(255, 255, 255, 0.04)",
                    borderRadius: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    transition: "all 0.3s ease",
                    border: isHovered
                      ? "1px solid rgba(110,193,228,0.3)"
                      : "1px solid transparent",
                  }}
                >
                  {spec.icon}
                </div>
                <h3
                  style={{
                    fontSize: "17px",
                    fontWeight: "800",
                    letterSpacing: "1px",
                    color: "#ffffff",
                    margin: "0 0 6px 0",
                  }}
                >
                  {spec.title}
                </h3>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#6ec1e4",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    marginBottom: "18px",
                  }}
                >
                  {spec.subtitle}
                </div>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#b3bfc4",
                    lineHeight: "1.7",
                    fontWeight: "300",
                    margin: 0,
                  }}
                >
                  {spec.desc}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom Scientific Specification Ribbon Bar */}
        <div
          style={{
            marginTop: isMobile ? "50px" : "80px",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            border: "1px solid rgba(255, 255, 255, 0.04)",
            borderRadius: "24px",
            padding: isMobile ? "30px 20px" : "35px 50px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: isMobile ? "30px" : "20px",
            textAlign: "center",
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: isMobile ? "32px" : "40px",
                fontWeight: "900",
                color: "#6ec1e4",
                marginBottom: "4px",
                fontFamily: "monospace",
              }}
            >
              100%
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "#cfd8dc",
                letterSpacing: "1.5px",
                fontWeight: "500",
                textTransform: "uppercase",
              }}
            >
              ISI Certified Safe
            </div>
          </div>

          <div
            style={{
              flex: 1,
              borderLeft: isMobile ? "none" : "1px solid rgba(255,255,255,0.1)",
              borderRight: isMobile ? "none" : "1px solid rgba(255,255,255,0.1)",
              padding: isMobile ? "20px 0" : "0 20px",
            }}
          >
            <div
              style={{
                fontSize: isMobile ? "32px" : "40px",
                fontWeight: "900",
                color: "#6ec1e4",
                marginBottom: "4px",
                fontFamily: "monospace",
              }}
            >
              Optimum
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "#cfd8dc",
                letterSpacing: "1.5px",
                fontWeight: "500",
                textTransform: "uppercase",
              }}
            >
              Minerals Re-infused
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: isMobile ? "32px" : "40px",
                fontWeight: "900",
                color: "#6ec1e4",
                marginBottom: "4px",
                fontFamily: "monospace",
              }}
            >
              BPA
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "#cfd8dc",
                letterSpacing: "1.5px",
                fontWeight: "500",
                textTransform: "uppercase",
              }}
            >
              Free Food-Grade PET
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;